"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeUniqueValueInfo = exports.edgeUniqueValueInfo = void 0;
const UniqueValueInfo_1 = __importDefault(require("@arcgis/core/renderers/support/UniqueValueInfo"));
const CIMSymbol_1 = require("./CIMSymbol");
function getUrlName(name) {
    return name
        .replace('/', ' ')
        .replace('<', '-')
        .replace('>=', 'plus')
        .replace('+', 'plus')
        .replace(/ /g, '')
        .replace(/,/g, 'Comma')
        .replace(/-/g, 'Dash')
        .replace(/&/g, 'And')
        .replace(/[{()}]/g, 'Para')
        .replace(/0/g, 'Zero')
        .replace(/1/g, 'One')
        .replace(/2/g, 'Two')
        .replace(/3/g, 'Three')
        .replace(/4/g, 'Four')
        .replace(/5/g, 'Five')
        .replace(/6/g, 'Six')
        .replace(/7/g, 'Seven')
        .replace(/8/g, 'Eight')
        .replace(/9/g, 'Nine');
}
exports.edgeUniqueValueInfo = [
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('Connection line, under construction')),
        value: 'Connection line, under construction',
        label: 'Connection line, under construction',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('Connection line')),
        value: 'Connection line',
        label: 'Connection line',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('132-150 kV Transmission Line Under Construction, 1 Circuit, underground')),
        value: '132-150 kV Transmission Line Under Construction, 1 Circuit, underground',
        label: '132-150 kV Transmission Line Under Construction, 1 Circuit, underground',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('132-150 kV Transmission Line Under Construction, 1 Circuit')),
        value: '132-150 kV Transmission Line Under Construction, 1 Circuit',
        label: '132-150 kV Transmission Line Under Construction, 1 Circuit',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('132-150 kV Transmission Line Under Construction, 2 Circuits')),
        value: '132-150 kV Transmission Line Under Construction, 2 Circuits',
        label: '132-150 kV Transmission Line Under Construction, 2 Circuits',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('132-150 kV Transmission Line, 1 Circuit')),
        value: '132-150 kV Transmission Line, 1 Circuit',
        label: '132-150 kV Transmission Line, 1 Circuit',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('132-150 kV Transmission Line, 1 Circuit, underground')),
        value: '132-150 kV Transmission Line, 1 Circuit, underground',
        label: '132-150 kV Transmission Line, 1 Circuit, underground',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('132-150 kV Transmission Line, 2 Circuits')),
        value: '132-150 kV Transmission Line, 2 Circuits',
        label: '132-150 kV Transmission Line, 2 Circuits',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('132-150 kV Transmission Line, 2 Circuits, underground')),
        value: '132-150 kV Transmission Line, 2 Circuits, underground',
        label: '132-150 kV Transmission Line, 2 Circuits, underground',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('220 kV Transmission Line Under Construction, 1 Circuit')),
        value: '220 kV Transmission Line Under Construction, 1 Circuit',
        label: '220 kV Transmission Line Under Construction, 1 Circuit',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('220 kV Transmission Line Under Construction, 1 Circuit, underground')),
        value: '220 kV Transmission Line Under Construction, 1 Circuit, underground',
        label: '220 kV Transmission Line Under Construction, 1 Circuit, underground',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('220 kV Transmission Line Under Construction, 2 Circuits')),
        value: '220 kV Transmission Line Under Construction, 2 Circuits',
        label: '220 kV Transmission Line Under Construction, 2 Circuits',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('220 kV Transmission Line, 1 Circuit')),
        value: '220 kV Transmission Line, 1 Circuit',
        label: '220 kV Transmission Line, 1 Circuit',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('220 kV Transmission Line, 1 Circuit, underground')),
        value: '220 kV Transmission Line, 1 Circuit, underground',
        label: '220 kV Transmission Line, 1 Circuit, underground',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('220 kV Transmission Line, 2 Circuits')),
        value: '220 kV Transmission Line, 2 Circuits',
        label: '220 kV Transmission Line, 2 Circuits',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('220 kV Transmission Line, 2 Circuits, underground')),
        value: '220 kV Transmission Line, 2 Circuits, underground',
        label: '220 kV Transmission Line, 2 Circuits, underground',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('220 kV Transmission Line, 2 Circuits with 1 Circuit Mounted')),
        value: '220 kV Transmission Line, 2 Circuits with 1 Circuit Mounted',
        label: '220 kV Transmission Line, 2 Circuits with 1 Circuit Mounted',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('220 kV Transmission Line, >= 3 Circuits')),
        value: '220 kV Transmission Line, >= 3 Circuits',
        label: '220 kV Transmission Line, >= 3 Circuits',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('300-330 kV Transmission Line Under Construction, 1 Circuit')),
        value: '300-330 kV Transmission Line Under Construction, 1 Circuit',
        label: '300-330 kV Transmission Line Under Construction, 1 Circuit',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('300-330 kV Transmission Line Under Construction, 2 Circuits')),
        value: '300-330 kV Transmission Line Under Construction, 2 Circuits',
        label: '300-330 kV Transmission Line Under Construction, 2 Circuits',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('300-330 kV Transmission Line, 1 Circuit')),
        value: '300-330 kV Transmission Line, 1 Circuit',
        label: '300-330 kV Transmission Line, 1 Circuit',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('300-330 kV Transmission Line, 1 Circuit, underground')),
        value: '300-330 kV Transmission Line, 1 Circuit, underground',
        label: '300-330 kV Transmission Line, 1 Circuit, underground',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('300-330 kV Transmission Line, 2 Circuits')),
        value: '300-330 kV Transmission Line, 2 Circuits',
        label: '300-330 kV Transmission Line, 2 Circuits',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('300-330 kV Transmission Line, >= 3 Circuits')),
        value: '300-330 kV Transmission Line, >= 3 Circuits',
        label: '300-330 kV Transmission Line, >= 3 Circuits',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('380-400 kV Transmission Line Under Construction, 1 Circuit')),
        value: '380-400 kV Transmission Line Under Construction, 1 Circuit',
        label: '380-400 kV Transmission Line Under Construction, 1 Circuit',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('380-400 kV Transmission Line Under Construction, 2 Circuits')),
        value: '380-400 kV Transmission Line Under Construction, 2 Circuits',
        label: '380-400 kV Transmission Line Under Construction, 2 Circuits',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('380-400 kV Transmission Line Under Construction, >= 3 Circuits')),
        value: '380-400 kV Transmission Line Under Construction, >= 3 Circuits',
        label: '380-400 kV Transmission Line Under Construction, >= 3 Circuits',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('380-400 kV Transmission Line, 1 Circuit')),
        value: '380-400 kV Transmission Line, 1 Circuit',
        label: '380-400 kV Transmission Line, 1 Circuit',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('380-400 kV Transmission Line, 2 Circuits')),
        value: '380-400 kV Transmission Line, 2 Circuits',
        label: '380-400 kV Transmission Line, 2 Circuits',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('380-400 kV Transmission Line, 2 Circuits, underground')),
        value: '380-400 kV Transmission Line, 2 Circuits, underground',
        label: '380-400 kV Transmission Line, 2 Circuits, underground',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('380-400 kV Transmission Line, 2 Circuits with 1 Circuit Mounted')),
        value: '380-400 kV Transmission Line, 2 Circuits with 1 Circuit Mounted',
        label: '380-400 kV Transmission Line, 2 Circuits with 1 Circuit Mounted',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('380-400 kV Transmission Line Under Construction, 2 Circuits with 1 Circuit Mounted')),
        value: '380-400 kV Transmission Line Under Construction, 2 Circuits with 1 Circuit Mounted',
        label: '380-400 kV Transmission Line Under Construction, 2 Circuits with 1 Circuit Mounted',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('380-400 kV Transmission Line, >= 3 Circuits')),
        value: '380-400 kV Transmission Line, >= 3 Circuits',
        label: '380-400 kV Transmission Line, >= 3 Circuits',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('380-400 kV Transmission Line, 1 Circuit, underground')),
        value: '380-400 kV Transmission Line, 1 Circuit, underground',
        label: '380-400 kV Transmission Line, 1 Circuit, underground',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('500 kV Transmission Line Under Construction, 1 Circuit')),
        value: '500 kV Transmission Line Under Construction, 1 Circuit',
        label: '500 kV Transmission Line Under Construction, 1 Circuit',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('500 kV Transmission Line Under Construction, 2 Circuits')),
        value: '500 kV Transmission Line Under Construction, 2 Circuits',
        label: '500 kV Transmission Line Under Construction, 2 Circuits',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('500 kV Transmission Line, 1 Circuit')),
        value: '500 kV Transmission Line, 1 Circuit',
        label: '500 kV Transmission Line, 1 Circuit',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('500 kV Transmission Line, 2 Circuits')),
        value: '500 kV Transmission Line, 2 Circuits',
        label: '500 kV Transmission Line, 2 Circuits',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('750 kV Transmission Line Under Construction, 1 Circuit')),
        value: '750 kV Transmission Line Under Construction, 1 Circuit',
        label: '750 kV Transmission Line Under Construction, 1 Circuit',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('750 kV Transmission Line, 1 Circuit')),
        value: '750 kV Transmission Line, 1 Circuit',
        label: '750 kV Transmission Line, 1 Circuit',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('DC-Line Under Construction, 1 Circuit')),
        value: 'DC-Line Under Construction, 1 Circuit',
        label: 'DC-Line Under Construction, 1 Circuit',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('DC-Line Under Construction, 2 Circuits')),
        value: 'DC-Line Under Construction, 2 Circuits',
        label: 'DC-Line Under Construction, 2 Circuits',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('DC-Line, 1 Circuit')),
        value: 'DC-Line, 1 Circuit',
        label: 'DC-Line, 1 Circuit',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('DC-Line, 2 Circuits')),
        value: 'DC-Line, 2 Circuits',
        label: 'DC-Line, 2 Circuits',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('DC-Line, 2 Circuits, underground')),
        value: 'DC-Line, 2 Circuits, underground',
        label: 'DC-Line, 2 Circuits, underground',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('DC-Line, 1 Circuit, underground')),
        value: 'DC-Line, 1 Circuit, underground',
        label: 'DC-Line, 1 Circuit, underground',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('Interconnection for Voltage < 200 kV, 1 Circuit')),
        value: 'Interconnection for Voltage < 200 kV, 1 Circuit',
        label: 'Interconnection for Voltage < 200 kV, 1 Circuit',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('Interconnection for Voltage < 200 kV, 1 Circuit, underground')),
        value: 'Interconnection for Voltage < 200 kV, 1 Circuit, underground',
        label: 'Interconnection for Voltage < 200 kV, 1 Circuit, underground',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolLineObject)(getUrlName('Interconnection for Voltage < 200 kV, 2 Circuits')),
        value: 'Interconnection for Voltage < 200 kV, 2 Circuits',
        label: 'Interconnection for Voltage < 200 kV, 2 Circuits',
    }),
];
exports.nodeUniqueValueInfo = [
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Biogas')),
        value: 'Biogas',
        label: 'Biogas',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Biogas, under construction')),
        value: 'Biogas, under construction',
        label: 'Biogas, under construction',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Biomass')),
        value: 'Biomass',
        label: 'Biomass',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Biomass, under construction')),
        value: 'Biomass, under construction',
        label: 'Biomass, under construction',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Brown coal/Lignite')),
        value: 'Brown coal/Lignite',
        label: 'Brown coal/Lignite',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Brown coal/Lignite, under construction')),
        value: 'Brown coal/Lignite, under construction',
        label: 'Brown coal/Lignite, under construction',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Coal derived gas')),
        value: 'Coal derived gas',
        label: 'Coal derived gas',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Converter Station Back-to-back')),
        value: 'Converter Station Back-to-back',
        label: 'Converter Station Back-to-back',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Converter Station Back-to-back, under construction')),
        value: 'Converter Station Back-to-back, under construction',
        label: 'Converter Station Back-to-back, under construction',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Converter Station')),
        value: 'Converter Station',
        label: 'Converter Station',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Converter Station, under construction')),
        value: 'Converter Station, under construction',
        label: 'Converter Station, under construction',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Fossil fuel')),
        value: 'Fossil fuel',
        label: 'Fossil fuel',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Fossil fuel, under construction')),
        value: 'Fossil fuel, under construction',
        label: 'Fossil fuel, under construction',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Fossil gas')),
        value: 'Fossil gas',
        label: 'Fossil gas',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Fossil gas, under construction')),
        value: 'Fossil gas, under construction',
        label: 'Fossil gas, under construction',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Fossil oil')),
        value: 'Fossil oil',
        label: 'Fossil oil',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Fossil oil, under construction')),
        value: 'Fossil oil, under construction',
        label: 'Fossil oil, under construction',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Fossil peat')),
        value: 'Fossil peat',
        label: 'Fossil peat',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Geothermal')),
        value: 'Geothermal',
        label: 'Geothermal',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Geothermal, under construction')),
        value: 'Geothermal, under construction',
        label: 'Geothermal, under construction',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Hard coal')),
        value: 'Hard coal',
        label: 'Hard coal',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Hard coal, under construction')),
        value: 'Hard coal, under construction',
        label: 'Hard coal, under construction',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Hydro mixed pump storage')),
        value: 'Hydro mixed pump storage',
        label: 'Hydro mixed pump storage',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Hydro mixed pump storage, under construction')),
        value: 'Hydro mixed pump storage, under construction',
        label: 'Hydro mixed pump storage, under construction',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Hydro pure pump storage')),
        value: 'Hydro pure pump storage',
        label: 'Hydro pure pump storage',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Hydro pure storage')),
        value: 'Hydro pure storage',
        label: 'Hydro pure storage',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Hydro pure storage, under construction')),
        value: 'Hydro pure storage, under construction',
        label: 'Hydro pure storage, under construction',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Hydro run of river & pondage')),
        value: 'Hydro run of river & pondage',
        label: 'Hydro run of river & pondage',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Hydro run of river & pondage, under construction')),
        value: 'Hydro run of river & pondage, under construction',
        label: 'Hydro run of river & pondage, under construction',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Mixed fuels')),
        value: 'Mixed fuels',
        label: 'Mixed fuels',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Mixed fuels, under construction')),
        value: 'Mixed fuels, under construction',
        label: 'Mixed fuels, under construction',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Nuclear')),
        value: 'Nuclear',
        label: 'Nuclear',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Nuclear, under construction')),
        value: 'Nuclear, under construction',
        label: 'Nuclear, under construction',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Oil shale')),
        value: 'Oil shale',
        label: 'Oil shale',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Other fossil fuels')),
        value: 'Other fossil fuels',
        label: 'Other fossil fuels',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Other or not listed')),
        value: 'Other or not listed',
        label: 'Other or not listed',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Other or not listed, under construction')),
        value: 'Other or not listed, under construction',
        label: 'Other or not listed, under construction',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Phase shifter')),
        value: 'Phase shifter',
        label: 'Phase shifter',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Phase shifter, under construction')),
        value: 'Phase shifter, under construction',
        label: 'Phase shifter, under construction',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Solar photovoltaic')),
        value: 'Solar photovoltaic',
        label: 'Solar photovoltaic',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Solar photovoltaic, under construction')),
        value: 'Solar photovoltaic, under construction',
        label: 'Solar photovoltaic, under construction',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Solar thermic')),
        value: 'Solar thermic',
        label: 'Solar thermic',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Solar')),
        value: 'Solar',
        label: 'Solar',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Substation')),
        value: 'Substation',
        label: 'Substation',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Substation, under construction')),
        value: 'Substation, under construction',
        label: 'Substation, under construction',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Substations + Power Plants')),
        value: 'Substations + Power Plants',
        label: 'Substations + Power Plants',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Waste (renewable)')),
        value: 'Waste (renewable)',
        label: 'Waste (renewable)',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Waste')),
        value: 'Waste',
        label: 'Waste',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Wind farm')),
        value: 'Wind farm',
        label: 'Wind farm',
    }),
    new UniqueValueInfo_1.default({
        symbol: (0, CIMSymbol_1.JsonToCIMSymbolPointObject)(getUrlName('Wind farm, under construction')),
        value: 'Wind farm, under construction',
        label: 'Wind farm, under construction',
    }),
];
